module.exports = __webpack_public_path__ + "img/photo-right.6b077e70.jpg";